import { useDocumentTitle } from "@/lib/use-document-title";
import { LegalLayout } from "@/components/LegalLayout";

export default function IntegritetspolicyPage() {
  useDocumentTitle("Integritetspolicy — Lagamobilen Access");
  return (
    <LegalLayout title="Integritetspolicy" updated="Senast uppdaterad 3 juni 2026">
      <section>
        <h2>
          <span className="section-number">1</span>
          Personuppgiftsansvarig
        </h2>
        <div className="contact-block">
          <p className="font-semibold">ResQ My Device AB</p>
          <p>Organisationsnummer: 559149-4496</p>
          <p>Hyllie stationsväg 10, 215 32 Malmö</p>
        </div>
        <p>
          Frågor om personuppgifter:{" "}
          <a href="mailto:ekonomi@lagamobilen.se">ekonomi@lagamobilen.se</a>
          <br />
          Kundärenden:{" "}
          <a href="mailto:access@lagamobilen.se">access@lagamobilen.se</a> · 040-125600
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">2</span>
          Vilka personuppgifter vi behandlar
        </h2>
        <ul>
          <li>
            <strong>Kontaktuppgifter:</strong> namn, e-postadress, telefonnummer
          </li>
          <li>
            <strong>Medlemskapsuppgifter:</strong> medlemsstatus, anslutningsdatum, vald butik
          </li>
          <li>
            <strong>Betalnings- och fakturauppgifter:</strong> fakturahistorik och betalningsstatus
            (fullständiga kortuppgifter hanteras enbart av Stripe)
          </li>
          <li>
            <strong>Förmånshistorik:</strong> loggar över nyttjade förmåner
          </li>
          <li>
            <strong>Eventregistreringar:</strong> anmälningar till medlemskvällar och event
          </li>
          <li>
            <strong>Kommunikationsloggar:</strong> utskickade e-post- och SMS-meddelanden
          </li>
        </ul>
      </section>

      <section>
        <h2>
          <span className="section-number">3</span>
          Ändamål och laglig grund
        </h2>
        <div className="data-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Ändamål</th>
                <th>Laglig grund</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Administrera medlemskap och leverera förmåner</td>
                <td>Fullgörande av avtal</td>
              </tr>
              <tr>
                <td>Hantera betalning och fakturering</td>
                <td>Fullgörande av avtal</td>
              </tr>
              <tr>
                <td>Skicka medlemsinformation via e-post och SMS</td>
                <td>Fullgörande av avtal / berättigat intresse</td>
              </tr>
              <tr>
                <td>Bokföring av transaktioner</td>
                <td>Rättslig förpliktelse (bokföringslagen)</td>
              </tr>
              <tr>
                <td>Kundtjänst och reklamationer</td>
                <td>Fullgörande av avtal / berättigat intresse</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>
          <span className="section-number">4</span>
          Mottagare av uppgifter
        </h2>
        <ul>
          <li>
            <strong>Stripe</strong> – betalningshantering (kortbetalning, prenumeration)
          </li>
          <li>
            <strong>Lovable Cloud / Supabase</strong> – teknisk lagring och drift
          </li>
          <li>
            <strong>E-postleverantör</strong> – för utskick av medlemskommunikation
          </li>
          <li>
            <strong>SMS-leverantör</strong> – för utskick av SMS kopplade till medlemskapet
          </li>
        </ul>
      </section>

      <section>
        <h2>
          <span className="section-number">5</span>
          Hur länge vi sparar uppgifter
        </h2>
        <p>
          Vi sparar dina personuppgifter så länge du har ett aktivt medlemskap. När medlemskapet
          avslutats raderas dina medlemsuppgifter, med undantag för bokföringsmaterial som sparas
          i 7 år enligt bokföringslagen.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">6</span>
          Dina rättigheter
        </h2>
        <p>Du har rätt att begära:</p>
        <ul>
          <li>Tillgång till dina personuppgifter (registerutdrag / datakopia)</li>
          <li>Rättelse av felaktiga uppgifter</li>
          <li>Radering ("rätten att bli glömd")</li>
          <li>Begränsning eller invändning mot behandling</li>
          <li>Dataportabilitet</li>
        </ul>
        <p>
          Begäran skickas till <a href="mailto:ekonomi@lagamobilen.se">ekonomi@lagamobilen.se</a>{" "}
          eller hanteras direkt via "Min profil → Begär datakopia" i medlemsportalen.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">7</span>
          Klagomål
        </h2>
        <p>
          Du har rätt att lämna klagomål till{" "}
          <a href="https://www.imy.se" target="_blank" rel="noreferrer">
            Integritetsskyddsmyndigheten (IMY)
          </a>
          .
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">8</span>
          Cookies
        </h2>
        <p>
          Vi använder endast nödvändiga cookies för inloggning och säkerhet. Inga
          marknadsförings- eller spårningscookies används utan ditt samtycke.
        </p>
      </section>
    </LegalLayout>
  );
}
